import { TFunction } from 'i18next';

export const translate = (t: TFunction, key: string, options?: Record<string, unknown>): string =>
  t(key, options) as string;
